```vue
<template> 
  <div ref="seccionContadorRef" class="seccion-editorial-container"> 
     
    <!-- 1. TOP BOW FULL-WIDTH (EDGE-TO-EDGE) --> 
    <div ref="monioRef" class="monio-full-width-wrapper"> 
      <img  
        src="@/assets/monio.png"  
        alt="Red Bow"  
        class="monio-img" 
      > 
    </div> 
 
    <!-- 2. MAIN DETACHED LAYOUT --> 
    <div class="contenido-editorial-wrapper"> 
 
      <!-- TEXT AND INFORMATION BLOCK (INDEPENDENT) --> 
      <div class="info-columna"> 
         
        <!-- EDITORIAL TITLE --> 
        <div ref="headerTextRef" class="header-text-block"> 
          <h2 class="the-details-title">Very Soon</h2> 
          <div class="linea-decorativa-gold"></div> 
        </div> 
 
        <!-- POETIC PHRASE --> 
        <div ref="fraseRef" class="frase-container"> 
          <p class="frase-linea">EVERY SECOND BRINGS ME CLOSER</p> 
          <p class="frase-linea">TO MY BIG DAY!</p> 
        </div> 
 
        <!-- COUNTDOWN TITLE --> 
        <div ref="tituloContadorRef" class="titulo-contador"> 
          <span class="solo-text">Only</span> 
          <span class="faltan-text">LEFT</span> 
        </div> 
 
        <!-- MINIMALIST COUNTDOWN (WITHOUT BOXES) --> 
        <div ref="gridNumerosRef" class="contador-limpio-grid"> 
          <div class="tiempo-item"> 
            <span class="numero">{{ dias }}</span> 
            <span class="etiqueta">Days</span> 
          </div> 
          <div class="tiempo-item"> 
            <span class="numero">{{ horas }}</span> 
            <span class="etiqueta">Hours</span> 
          </div> 
          <div class="tiempo-item"> 
            <span class="numero">{{ minutos }}</span> 
            <span class="etiqueta">Minutes</span> 
          </div> 
          <div class="tiempo-item"> 
            <span class="numero">{{ segundos }}</span> 
            <span class="etiqueta">Seconds</span> 
          </div> 
        </div> 
 
      </div> 
 
      <!-- DOLL ANCHORED TO THE LEFT EDGE AND BOTTOM --> 
      <div ref="muniecaRef" class="munieca-container"> 
        <img  
          src="@/assets/quinceañera.png"  
          alt="Quinceañera"  
          class="munieca-img" 
        > 
      </div> 
 
    </div> 
 
  </div> 
</template>
```


<script>
import { ref, onMounted, onUnmounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ContadorEditorialLimpio',
  setup() {
    const seccionContadorRef = ref(null)
    const monioRef = ref(null)
    const muniecaRef = ref(null)
    const headerTextRef = ref(null)
    const fraseRef = ref(null)
    const tituloContadorRef = ref(null)
    const gridNumerosRef = ref(null)

    const dias = ref('00')
    const horas = ref('00')
    const minutos = ref('00')
    const segundos = ref('00')

    let timerId = null

    const iniciarCuentaAtras = () => {
      const fechaEvento = new Date('2026-11-06T18:00:00')
      
      const calcularTiempo = () => {
        const ahora = new Date()
        const dif = fechaEvento - ahora

        if (dif <= 0) {
          dias.value = horas.value = minutos.value = segundos.value = '00'
          if (timerId) clearInterval(timerId)
          return
        }

        dias.value = String(Math.floor(dif / (1000 * 60 * 60 * 24))).padStart(2, '0')
        horas.value = String(Math.floor((dif / (1000 * 60 * 60)) % 24)).padStart(2, '0')
        minutos.value = String(Math.floor((dif / (1000 * 60)) % 60)).padStart(2, '0')
        segundos.value = String(Math.floor((dif / 1000) % 60)).padStart(2, '0')
      }

      calcularTiempo()
      timerId = setInterval(calcularTiempo, 1000)
    }

    onMounted(() => {
      iniciarCuentaAtras()

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: seccionContadorRef.value,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      })

      // 1. Moño superior desciende suavemente
      tl.from(monioRef.value, {
        opacity: 0,
        y: -25,
        duration: 1,
        ease: 'power2.out'
      })

      // 2. Bloque de título "Faltan Muy Poco"
      .from(headerTextRef.value, {
        opacity: 0,
        y: 20,
        duration: 0.8,
        ease: 'power2.out'
      }, '-=0.6')

      // 3. Frase poética
      .from(fraseRef.value, {
        opacity: 0,
        y: 15,
        duration: 0.7,
        ease: 'power2.out'
      }, '-=0.5')

      // 4. Título "Solo Faltan"
      .from(tituloContadorRef.value, {
        opacity: 0,
        scale: 0.95,
        duration: 0.6,
        ease: 'back.out(1.2)'
      }, '-=0.4')

      // 5. Números del contador
      .from(gridNumerosRef.value.children, {
        opacity: 0,
        y: 20,
        duration: 0.5,
        stagger: 0.08,
        ease: 'power2.out'
      }, '-=0.3')

      // 6. Muñeca emerge desde la izquierda
      .from(muniecaRef.value, {
        opacity: 0,
        x: -40,
        duration: 1.1,
        ease: 'power3.out'
      }, '-=0.8')
    })

    onUnmounted(() => {
      if (timerId) clearInterval(timerId)
    })

    return {
      seccionContadorRef,
      monioRef,
      muniecaRef,
      headerTextRef,
      fraseRef,
      tituloContadorRef,
      gridNumerosRef,
      dias,
      horas,
      minutos,
      segundos
    }
  }
}
</script>

<style scoped>
/* ==========================================
   1. CONTENEDOR GENERAL EDGE-TO-EDGE
   ========================================== */
.seccion-editorial-container {
  position: relative;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  min-height: 100vh;
  min-height: 100dvh; /* Para navegadores móviles */
  background-color: #ffffff;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  margin-top:-80px;
  margin-bottom: 130px;
  flex-direction: column;
}

/* ==========================================
   2. MOÑO SUPERIOR SIN MARGENES
   ========================================== */
.monio-full-width-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  z-index: 5;
}

.monio-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* ==========================================
   3. ESTRUCTURA EDITORIAL FLUIDA
   ========================================== */
.contenido-editorial-wrapper {
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  padding-top: 1.5vh;
  box-sizing: border-box;
}

/* COLUMNA DERECHA INDEPENDIENTE */
.info-columna {
  position: relative;
  z-index: 3;
  width: 60vw;
  margin-top: -4vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-right: 6vw;
  box-sizing: border-box;
}

/* MUÑECA ABSOLUTA CON DESPLAZAMIENTO RELATIVO */
.munieca-container {
  position: absolute;
  bottom: 0;
  top: -5vh;
  left: -80vw;
  height: 65vh;
  max-height: 520px;
  z-index: 1;
  pointer-events: none;
}

.munieca-img {
  height: 100%;
  width: auto;
  display: block;
  object-fit: contain;
  filter: drop-shadow(4px 6px 12px rgba(0, 0, 0, 0.08));
}

/* ==========================================
   4. TIPOGRAFÍAS Y ESTILOS CON CLAMP
   ========================================== */
.header-text-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.2vh;
}

.the-details-title {
  font-family: 'ludovica', serif;
  font-size: clamp(1.8rem, 8vw, 2.8rem);
  color: #B28F60;
  font-weight: 400;
  margin: 0;
  line-height: 1.1;
  white-space: nowrap;
}

.linea-decorativa-gold {
  width: clamp(25px, 8vw, 40px);
  height: 1px;
  background: #B28F60;
  margin-top: 0.4vh;
  opacity: 0.5;
}

.frase-container {
  margin-bottom: 1.4vh;
}

.frase-linea {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.6rem, 2.6vw, 0.75rem);
  color: #B28F60;
  margin: 0;
  line-height: 1.4;
  font-weight: 600;
  letter-spacing: 0.1em;
}

.titulo-contador {
  margin-bottom: 1.2vh;
}

.solo-text {
  font-family: 'ludovica', serif;
  font-size: clamp(1.4rem, 6vw, 2rem);
  color: #B28F60;
  display: block;
  line-height: 1;
}

.faltan-text {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.85rem, 3.8vw, 1.1rem);
  color: #ee93bd;
  font-weight: 700;
  letter-spacing: 0.15em;
  display: block;
  margin-top: -0.2vh;
}

/* ==========================================
   5. CONTANEDOR CONTADOR
   ========================================== */
.contador-limpio-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 4vw;
  row-gap: 1.2vh;
  width: 100%;
  max-width: 45vw;
}

.tiempo-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  border: none;
  box-shadow: none;
}

.numero {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.5rem, 7vw, 2.2rem);
  font-weight: 600;
  color: #ee93bd;
  line-height: 1;
}

.etiqueta {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.55rem, 2.3vw, 0.7rem);
  color: #B28F60;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-top: 0.4vh;
  font-weight: 500;
}
</style>